// extracted by mini-css-extract-plugin
export default {"menuBlock":"EG-z","title":"FG-z","nav":"GG-z","flexCell":"HG-z","facetLink":"IG-z"};